export const config = {
  url: `https://admin.bayanatspeech.com/`,
  // url: `http://localhost:8000/`,
  // media: `http://localhost:8000/media/`,
  media: `https://admin.bayanatspeech.com/media/`,
  frontEndUrl: `https://bayanatspeech.com/`,
  // frontEndUrl: `http://localhost:3000/`,
};
